import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleTypeTooltipHeader: {
        id: 'ml.policychange.pup.exposures.addVehicle.Which vehicle type should I select?',
        defaultMessage: 'Which vehicle type should I select?'
    },
    vehicleTypeTooltipContent: {
        id: 'ml.policychange.pup.exposures.addVehicle.Vehicle Type Tooltip Content',
        defaultMessage: '{ulSection}{policyState}'
    },
    vehicleTypeTooltipContentForAgent: {
        id: 'ml.policychange.pup.exposures.addVehicle.Vehicle Type Tooltip Content For Agent',
        defaultMessage: '{ulSection}'
    },
    whatIsPrivatePassengerLightTruck: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of private Passenger/light truck',
        defaultMessage: 'Private Passenger/light truck if you have the following: private passenger auto including a station wagon.'
    },
    whatIsPickupTruck: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Pickup truck',
        defaultMessage: 'Pickup Truck if you have a light duty truck with an enclosed cab and open cargo area.'
    },
    whatIsVanSUV: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Van/SUV',
        defaultMessage: 'Van/SUV if you have a van that can transport people or goods but does not need a commercial or special drivers license to operate or if you have a sport utility vehicle that is operated as a family vehicle.'
    },
    whatIsPanelTruck: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Panel truck',
        defaultMessage: 'Panel Truck if you have a vehicle which is a small enclosed van with a rear cargo area typically used for transporting or delivering goods.'
    },
    whatIsFlatBedOrBoxTruck: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Flat-Bed or Box truck',
        defaultMessage: 'Flat-Bed or Box Truck if you have a flatbed truck with an entirely flat, level bed with no sides or roof or a box truck with a fully enclosed box designed to transport cargo. These are vehicles which do not require a commercial or special drivers license to operate.'
    },
    whatIsCollectible: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Collectible',
        defaultMessage: 'Collectible if you have a vehicle which is unique or vintage and is collectible in nature. Categories for collectible vehicles include:'
    },
    whatIsAntique: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Antique',
        defaultMessage: 'Antique Vehicles which are 1) licensed as an antique with the Department of Motor Vehicles; or 2) 25 years old or older and in running condition. Vehicles may be driven only on a limited basis. Vehicles kept only for use as parts are not eligible.'
    },
    whatIsClassic: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Classic',
        defaultMessage: 'Classic Vehicles that are at least 10 years old and of limited production or of rare or historic interest through being restored, maintained or preserved. These vehicles appreciate in value (from their original price new) as they become older.'
    },
    whatIsReplicaReproductions: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Replica Reproductions',
        defaultMessage: 'Replica Reproductions of an antique or classic vehicle. Generally following the design and features of an older out of production vehicle, but manufactured and assembled with newer parts and equipment.'
    },
    whatIsCustom: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Custom',
        defaultMessage: 'Custom A vehicle which has been custom built, including kit cars, or has been significantly modified from its original specifications.'
    },
    whatIsLowSpeed: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Low Speed',
        defaultMessage: 'Low Speed Vehicle if you have a low speed vehicle or neighborhood electric vehicle (NEV). In most states, vehicles are considered low speed when they are less than 35 miles per hour.'
    },
    whatIsGolfCart: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Golf cart',
        defaultMessage: 'Golf cart which is small motorized vehicle for golfers and their equipment.'
    },
    whatIsATVSnowmobile: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of ATV/Snowmobile',
        defaultMessage: 'ATV/Snowmobile if you have an four-wheel all-terrain vehicle or a snowmobile.'
    },
    whatIsTrailers: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Trailers',
        defaultMessage: 'Trailers do not need to be added to the umbrella policy. Liability coverage automatically extends to a trailer, as long as the vehicle pulling it is covered under the umbrella.'
    },
    whatIsOtherVehicles: {
        id: 'ml.policychange.pup.exposures.addVehicle.Definition of Other Personally Registered Vehicles',
        defaultMessage: 'Other Personally Registered Vehicles:  Vehicles registered for use on public roads, which are not Private Passenger Autos; Pickups; Vans; Motorcycles; Motorhomes; Off-Road Recreational Vehicles, such as golf carts, ATVs, and snowmobiles; or Collectible or Antique cars, trucks, and motorcycles. Examples include armored military vehicles, tanks, and amphibious automobiles.'
    },
    vinResponseInValid: {
        id: 'ml.policychange.pup.exposures.addVehicle.vinResponse.inValidVIN',
        defaultMessage: ' is invalid. Please confirm the VIN listed is accurate, then enter the Vehicle Type, Year, Make, and Model and select Lookup VIN. If the model is not listed in the dropdown, please click Model Not Listed and enter the required fields.'
    },
    nonOwnerPolicyError: {
        id: 'ml.policychange.pup.exposures.addVehicle.You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy',
        defaultMessage: 'You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy. To proceed, remove the vehicle or update Policy information.'
    },
    vinLookupErrorMessage: {
        id: 'ml.policychange.pup.exposures.addVehicle.Vin Lookup Error Message',
        defaultMessage: 'Unable to look up vehicle information by VIN. Please enter the Make, Model and Year of this vehicle.'
    },
    findSerialNumber: {
        id: 'ml.policychange.pup.exposures.addVehicle.Where do I find my VIN/Serial Number?',
        defaultMessage: 'Where do I find my VIN/Serial Number?'
    },
    findVin: {
        id: 'ml.policychange.pup.exposures.addVehicle.Where do I find my VIN?',
        defaultMessage: 'Where do I find my VIN?'
    },
    whereVinSerialAns: {
        id: 'ml.policychange.pup.exposures.addVehicle.Where vin/serial ans',
        defaultMessage: 'The VIN (vehicle identification number) or serial number is used by the auto industry to identify individual motor vehicles.  By entering the VIN, we can automatically validate the specifics of the vehicle and provide a more accurate car insurance quote, including applicable discounts.  The VIN can be found in several places on a vehicle including the driver’s side dashboard and driver’s side doorjamb.   The serial number on a snowmobile is typically located on the right side of the tunnel and for most golf carts, the serial number is located by the glove box. On a motorcycle, the VIN is typically located on the steering neck or on the motor near the bottom of the cylinders'
    },
    whereVinAns: {
        id: 'ml.policychange.pup.exposures.addVehicle.Where Vin Ans',
        defaultMessage: 'The VIN (vehicle identification number) is  used by the auto industry to identify individual motor vehicles.  By entering the VIN, we can automatically validate the specifics of the vehicle and provide a more accurate car insurance quote, including applicable discounts.  The VIN can be found in several places on a vehicle including the driver’s side dashboard and driver’s side doorjamb.'
    }

});
